var next = __webpack_require__.x;
__webpack_require__.x = () => {
	__webpack_require__.e("commonjs");
	return next();
};